import { Global } from '@emotion/react';
import { Box } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router';

import Alert from '../util/Alert';
import { formBuilderStyles } from './styles';

const classes = {
	root: {
		width: '100%',
		backgroundColor: (theme) => theme.palette.background.default,
		minHeight: '100vh',
	},
	content: {
		width: '100%',
		overflow: 'auto',
	},
	title: {
		margin: '10px 0 10px 0',
	},
};

export function FormBuilderLayout() {
	return (
		<>
			<Global styles={formBuilderStyles} />
			<Box sx={classes.root} data-testid="form-builder">
				<Box sx={classes.content}>
					<Outlet />
				</Box>
				<Alert />
			</Box>
		</>
	);
}
